































































































































































import {
  getCurrentInstance,
  ComponentInternalInstance,
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { ChevronLeftIcon, CloseIcon, InfoCircleFilledIcon, InfoCircleIcon } from 'tdesign-icons-vue';

// 引入 compositions
import UserConfigBar from '@/renderer/views/desktop/ManageConsole/UserManagement/components/configBar.vue';
import PasswordBar from '@/renderer/views/desktop/ManageConsole/UserManagement/components/passwordBar.vue';
import SpaceConfig from '@/renderer/views/desktop/ManageConsole/UserManagement/components/spaceConfig.vue';
import userValidator, {
  validateAccountName,
  validatePhoneNumber,
} from '@/renderer/components/user/compositions/userValidator';

// 引入工具类
import phonePrefixOptions from '@/renderer/scripts/utils/phonePrefix';
import * as ConstantI18NConfig from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import { formatSize, phoneCompose } from '@/renderer/scripts/utils/tools/index';
import { phonePrefixFilter } from '@/renderer/common/phoneUtils';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
type PropsUserInfo = {
  accountName: string;
  nickname: string;
  comment: string;
  id?: number;
  countryCode: string;
  phoneNumber: string;
  allowPersonalSpace: boolean;
  capacity: string;
  role: string;
  enabled: boolean;
  needChangePassword: boolean;
};
type FormData = {
  account: string;
  createPassword: string;
  nickname: string;
  comment: string;
  countryCode: string;
  phoneNumber: string;
  enabled: boolean;
};
const defaultUserInfo = {
  account: '',
  password: '',
  nickname: '',
  comment: '',
  countryCode: '+86',
  phoneNumber: '',
  enabled: false,
};
export default defineComponent({
  name: 'importExtUserDialog',
  components: {
    ChevronLeftIcon,
    CloseIcon,
    InfoCircleFilledIcon,
    UserConfigBar,
    PasswordBar,
    SpaceConfig,
    InfoCircleIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    opType: String,
    userInfo: {
      type: Object as () => PropsUserInfo,
      required: true,
    },
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        // 在编辑空间时 点击关闭弹窗回到第一页
        if (!val && spaceEditing.value) {
          spaceEditing.value = false;
          return;
        }
        context.emit('update:show', val);
      },
    });
    const currentUser = computed(() => context.root.$store.getters.userBaseInfo);
    // 当前用户是超管
    const currentIsSuperAdmin = computed(() => currentUser.value.role === 'superAdmin');
    // 当前用户是系管
    const currentIsSysAdmin = computed(() => currentUser.value.role === 'admin');
    // 自己编辑自己
    const editingSelf = computed(() => props.userInfo.id === currentUser.value.userId);

    // user传递过来有默认值
    const _userInfo: FormData = {
      ...defaultUserInfo,
      createPassword: defaultUserInfo.password,
    };
    const formData = reactive<FormData>(_.cloneDeep(_userInfo));
    const operType = computed(() => props.opType);
    const accountMaxLength = 64;
    const phoneMaxLen = computed(() => (formData.countryCode === '+86' ? 11 : 20));
    const { nicknameMaxLength, commentMaxLength } = ConstantConfig;
    const { userRole: userRoleMap } = ConstantI18NConfig;
    const allRules = computed(() => {
      const { rules } = userValidator(formData, operType.value === 'update' ? ['phoneNumber'] : undefined);
      return rules;
    });

    // 表单输入是否合法
    const accountNameValidated = computed(() => validateAccountName(formData.account));
    const passwordValidated = computed(() =>
      operType.value === 'add'
        ? (formData.createPassword as string).length >= 8 && (formData.createPassword as string).length <= 100
        : true,
    );
    const nicknameValidated = computed(() => formData.nickname.length > 0 && formData.nickname.length <= 100);
    const phoneNumberValidated = computed(() => validatePhoneNumber(formData.countryCode, formData.phoneNumber));
    const commentValidated = computed(
      () => !formData.comment || (formData.comment && formData.comment.length <= commentMaxLength),
    );
    const formValidated = computed(() => {
      let baseValidated = false;
      if (store.getters.onlyPasswordLogin) {
        let accounNameValidated = accountNameValidated.value;
        // 超管的账号不需要校验
        if (operType.value === 'update' && props.userInfo.role === 'superAdmin') {
          accounNameValidated = true;
        }
        baseValidated = accounNameValidated && passwordValidated.value;
      } else {
        // 在修改信息&无手机号时无需校验手机号
        if (operType.value === 'update' && !formData.phoneNumber) {
          baseValidated = true;
        } else {
          baseValidated = phoneNumberValidated.value;
        }
      }
      return baseValidated && nicknameValidated.value && commentValidated.value;
    });

    // 编辑时表单是否变化了
    const formChanged = computed(() => {
      if (operType.value === 'add') return true;
      const accountNameChanged = formData.account !== props.userInfo.accountName;
      let countryCodeChanged = formData.countryCode !== props.userInfo.countryCode;
      const phoneNumberChanged = formData.phoneNumber !== props.userInfo.phoneNumber;
      const nicknameChanged = formData.nickname !== props.userInfo.nickname;
      const commentChanged = formData.comment !== props.userInfo.comment;
      const allowPersonalSpaceChanged = spaceSizeInfo.allowPersonalSpace !== props.userInfo.allowPersonalSpace;
      const personalSizeChanged = +spaceSizeInfo.personalSpaceQuotaSize !== +props.userInfo.capacity;
      const roleChanged = userRole.value !== props.userInfo.role;
      const baseChanged =
        nicknameChanged || commentChanged || allowPersonalSpaceChanged || personalSizeChanged || roleChanged;
      if (store.getters.onlyPasswordLogin) {
        return accountNameChanged || baseChanged;
      }
      if (operType.value === 'update' && !props.userInfo.phoneNumber) {
        countryCodeChanged = false;
      }
      return countryCodeChanged || phoneNumberChanged || baseChanged;
    });

    // 空间设置 默认为初始化设置
    const { defaultUserOptions } = store.getters;
    const spaceSizeInfo = reactive({
      allowPersonalSpace: defaultUserOptions.allowPersonalSpace,
      personalSpaceQuotaSize: defaultUserOptions.personalSpaceQuotaSize || '',
      orgAvailableSpace: '0',
      orgAvailableSpaceInfo: {
        size: 0,
        unit: 'B',
      },
    });
    const userRole = ref('user');
    const spaceEditing = ref(false);
    const showPasswordBar = computed(() => {
      if (!props.userInfo.accountName) return false;
      if (!props.userInfo.enabled) return false;
      if (operType.value === 'add') return false;
      // 自己不能给自己重置密码
      if (editingSelf.value) return false;
      // 系管没有初始化入口
      if (currentIsSysAdmin.value) return false;
      if (currentIsSuperAdmin.value) return true;
      return false;
    });
    const methods = {
      phonePrefixFilter,
      phoneCompose,
      // 手机前缀改变
      handleCodeChange(val: any) {
        if (formData.phoneNumber && formData.phoneNumber.length > phoneMaxLen.value) {
          formData.phoneNumber = formData.phoneNumber.substring(0, phoneMaxLen.value);
        }
      },
      async initData() {
        if (operType.value === 'update') {
          const { userInfo } = props;
          const {
            accountName,
            countryCode,
            phoneNumber,
            allowPersonalSpace,
            capacity,
            nickname,
            comment,
            role,
            enabled,
          } = userInfo as any;
          spaceSizeInfo.allowPersonalSpace = allowPersonalSpace;
          spaceSizeInfo.personalSpaceQuotaSize = capacity || '';
          formData.account = accountName;
          formData.nickname = nickname;
          formData.comment = comment;
          formData.countryCode = countryCode || defaultUserInfo.countryCode;
          formData.phoneNumber = phoneNumber;
          formData.enabled = enabled;
          userRole.value = role;
        } else {
          // 生成随机密码
          methods.createRandomPassword();
          formData.enabled = defaultUserOptions.enabled;
        }

        // 获取企业剩余额度
        const { availableSpace } = await store.dispatch('GetOrgSpace');
        spaceSizeInfo.orgAvailableSpace = availableSpace;
        const spaceInfo = formatSize(availableSpace);
        spaceSizeInfo.orgAvailableSpaceInfo = {
          size: spaceInfo.size,
          unit: spaceInfo.unit,
        };
      },
      // 生成一个随机密码
      getRandomPassword() {
        // 符号集
        const s = ['+', '_', '~', '@', '#', '$', '%', '^', '&', '*'];
        // 字母集
        const a = [];
        // 数字集
        const n = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
        for (let i = 97; i < 123; i++) {
          a.push(String.fromCharCode(i));
        }
        const getStr = (arr: any[], num: number) => {
          let str = '';
          for (let i = 0; i < num; i++) {
            str += arr[Math.floor(Math.random() * arr.length)];
          }
          return str;
        };
        // 默认取3字母2字符3数字
        return `${getStr(a, 3)}${getStr(s, 2)}${getStr(n, 3)}`;
      },
      createRandomPassword() {
        const randomPassword = methods.getRandomPassword();
        formData.createPassword = randomPassword;
      },
      onRoleChange(val: string) {
        userRole.value = val;
      },
      onSizeChanged({
        allowPersonalSpace,
        personalSpaceQuotaSize,
      }: {
        allowPersonalSpace: boolean;
        personalSpaceQuotaSize: string;
      }) {
        spaceSizeInfo.allowPersonalSpace = allowPersonalSpace;
        spaceSizeInfo.personalSpaceQuotaSize = personalSpaceQuotaSize;
      },
      // 点击确认
      async onConfirm() {
        const params = {
          nickname: formData.nickname,
          comment: formData.comment,
          allowPersonalSpace: spaceSizeInfo.allowPersonalSpace,
          personalSpaceQuotaSize: spaceSizeInfo.personalSpaceQuotaSize,
          role: userRole.value,
          enabled: formData.enabled,
        };
        if (store.getters.onlyPasswordLogin) {
          Object.assign(params, {
            accountName: formData.account,
            accountPassword: formData.createPassword,
          });
        } else {
          Object.assign(params, {
            countryCode: formData.countryCode,
            phoneNumber: formData.phoneNumber,
          });
        }
        if (operType.value === 'add') {
          context.emit('submit', {
            type: 'add',
            info: {
              form: params,
            },
          });
        } else {
          const { userInfo } = props;
          context.emit('submit', {
            type: 'update',
            info: {
              userId: userInfo.id,
              form: params,
            },
          });
        }
      },
    };
    methods.initData();
    watch(
      () => props.userInfo,
      val => {
        if (val) {
          Object.assign(formData, props.userInfo);
        } else {
          Object.assign(formData, defaultUserInfo);
        }
      },
    );
    return {
      innerShow,
      formData,
      operType,
      allRules,
      accountMaxLength,
      phoneMaxLen,
      formValidated,
      nicknameMaxLength,
      commentMaxLength,
      phonePrefixOptions,
      userRoleMap,
      currentIsSuperAdmin,
      currentIsSysAdmin,
      showPasswordBar,
      formChanged,
      spaceEditing,
      spaceSizeInfo,
      userRole,
      ...methods,
    };
  },
});
